import { render, staticRenderFns } from "./Ensayo.vue?vue&type=template&id=ff58d5da"
import script from "./Ensayo.vue?vue&type=script&lang=js"
export * from "./Ensayo.vue?vue&type=script&lang=js"
import style0 from "./Ensayo.vue?vue&type=style&index=0&id=ff58d5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports